import { render, staticRenderFns } from "./HerstellerumsaetzeTabelle.vue?vue&type=template&id=9804c312&scoped=true&"
import script from "./HerstellerumsaetzeTabelle.vue?vue&type=script&lang=js&"
export * from "./HerstellerumsaetzeTabelle.vue?vue&type=script&lang=js&"
import style0 from "./HerstellerumsaetzeTabelle.vue?vue&type=style&index=0&id=9804c312&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9804c312",
  null
  
)

export default component.exports